import axios from 'axios'

export default axios.create({
  baseURL: `https://nameless-cove-00105.herokuapp.com`
})